import { jsx, Fragment } from 'react/jsx-runtime';
import { FormControl as FormControl$1 } from 'baseui/form-control';
import { mergeOverrides } from '../../overrides.js';
import 'react';
import 'baseui';
import '../../theme/olx-theme/base-theme.js';
import '../../theme/olx-theme/theme.js';
import { useResolvedStyle } from '../../theme/utils.js';
import '../../theme/types.js';
import { Caption } from './caption.js';
import { LabelEndEnhancer } from './label-end-enhancer.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getStyles = ({ $theme, $disabled, $required }, element) => {
  switch (element) {
    case "LabelContainer":
      return __spreadValues({
        marginTop: 0,
        marginBottom: $theme.space[4]
      }, $disabled && {
        color: $theme.colors["text-global-disabled"]
      });
    case "Label":
      return __spreadValues(__spreadProps(__spreadValues({}, $theme.typography.p3), {
        color: "inherit"
      }), $required && {
        "::after": {
          content: '"*"'
        }
      });
    default:
      return {};
  }
};
const FormControl = (_a) => {
  var _b = _a, { overrides, counter, labelEndEnhancer, caption, $style, required, error } = _b, props = __objRest(_b, ["overrides", "counter", "labelEndEnhancer", "caption", "$style", "required", "error"]);
  var _a2;
  const resolvedStyle = (_a2 = useResolvedStyle($style)) != null ? _a2 : {};
  const hasCounter = typeof counter === "object";
  return jsx(FormControl$1, __spreadValues({
    overrides: mergeOverrides({
      LabelContainer: {
        style: (styleProps) => getStyles(styleProps, "LabelContainer")
      },
      Label: {
        style: (styleProps) => getStyles(__spreadProps(__spreadValues({}, styleProps), { $required: required }), "Label")
      },
      Caption: {
        component: Caption,
        props: __spreadValues({
          counter
        }, error && {
          role: "alert",
          "aria-live": "assertive"
        })
      },
      LabelEndEnhancer: {
        component: LabelEndEnhancer,
        props: {
          labelEndEnhancer
        }
      },
      ControlContainer: {
        style: resolvedStyle
      }
    }, overrides),
    counter,
    // A hack to render counter (if exists) but no caption was provided
    // This is due to baseweb Caption render condition (!!caption || !!error || !!positive)
    // eslint-disable-next-line react/jsx-no-useless-fragment
    caption: !caption && hasCounter ? jsx(Fragment, {}) : caption,
    error
  }, props));
};

export { FormControl };
